import React, {useState, useEffect} from 'react';
import { Layout, Menu, Breadcrumb, Input } from 'antd';
import {Col,Row, Form, Button} from 'react-bootstrap';
import { Segment } from 'semantic-ui-react';
import './Demo.css';
import {listBaseStr, dnaSet, replaceChat, getRandomLetter, arrSort} from './Common.js';
import SideMenu from './SideMenu';

const { SubMenu } = Menu;
const { Header, Content, Footer, Sider } = Layout;
const { TextArea } = Input;

export default function Tool02() {

    const [sequence, setSequence] = useState("");
    const [count, setCount] = useState("");
    const [result, setResult] = useState([]);

    function handleSequence(e){
        let current = e.target.value;
        // console.log(current);
        setSequence(current);
    }
    
    function handleCount(e){
        let current = e.target.value;
        // console.log(current);
        setCount(current);
    }

    function handleSubmit(){
            var sequenceArray = listBaseStr(sequence);
            var randomNum = 0; //位置随机数
            var mutateNum = count; //突变个数
            var mutateIndex = new Array(); //记录突变位置
            var letterArray = dnaSet;
            sequenceArray = sequenceArray.notempty();
            if (sequenceArray.length == 0){
                return null;
            }

            //算法思想 随机打乱序列取序号 即可得到重复位置的序列
            for (var i = 0; i < sequenceArray.length; i++) {
                var perLength = sequenceArray[i].length;
                var mutateArr = [];
                for (var j = 0; mutateArr.push(j++) < perLength;) {}
                mutateArr = mutateArr.shuffle();
                mutateArr.length = mutateNum;
                for (var k = 0; k < mutateNum; k++) {
                    sequenceArray[i] = replaceChat(sequenceArray[i], mutateArr[k], getRandomLetter(letterArray,
                        sequenceArray[i][mutateArr[k]]));
                }
                for (var n = 0; n < mutateNum; n++) {
                    mutateArr[n]++;
                }
                mutateIndex.push(mutateArr.sort(arrSort).toString());
            }

            //网页结果输出
            var result1 = "";
            console.log(sequenceArray);
            console.log(mutateIndex);
            for (let index = 0; index < sequenceArray.length; index++) {
                result1 += "第" + (index + 1) + "序列,突变位置为" + mutateIndex[index] + "\n" + sequenceArray[index] + "\n";
            }
            // document.getElementById("demo").innerHTML = result;
            console.log(result1);
            setResult(result1);
    }

    function processResult(e){
        let currentArr = "";
        for(let i=0;i<e.length;i++){
            let current = e[i].toString() + "\n";
            currentArr +=current;
        }
        return currentArr;
        
    }

    return (

        <Layout style={{height: "100vh"}}>
            <Header className="header" style={{minHeight: "5vh"}}>
                <div style={{fontSize:"2rem",color:"white"}}>BioTools</div>
            </Header>
            <Content style={{ padding: '5vh 50px', minHeight: "80vh",maxHeight:"80vh"}}>
            {/* <Breadcrumb style={{ margin: '16px 0' }}>
                <Breadcrumb.Item style={{fontSize:"1.5rem"}}>Tools 01</Breadcrumb.Item>
            </Breadcrumb> */}
            <Layout className="site-layout-background" >
                <Sider className="site-layout-background" width={200}>
                    <SideMenu params={["2"]} />
                </Sider>
                <Content style={{ background:"white", minHeight: "75vh",maxHeight:"75vh" }}>
                    <Segment basic style={{height:"100%"}} >
                        <Segment style={{height:"100%"}} >
                            <Row>
                                <Col sm={1} />
                                <Col>
                                    <Form>
                                        <div style={{height:"1rem"}} />
                                        <Form.Group className="mb-3" controlId="formBasicEmail">
                                            <Form.Label size="lg">序列</Form.Label>
                                            <TextArea
                                                // value={value}
                                                onChange={handleSequence}
                                                // placeholder="Controlled autosize"
                                                autoSize={{ minRows: 3, maxRows: 5 }}
                                            />
                                            <Form.Text className="text-muted">
                                            序列用空格和换行隔开
                                            </Form.Text>
                                        </Form.Group>
                                        <div style={{height:"1rem"}} />
                                        <Form.Group className="mb-3" controlId="formBasicEmail">
                                            <Form.Label size="lg">突变个数</Form.Label>
                                            <Form.Control type="number" onChange={handleCount}  />
                                            
                                        </Form.Group>
                                        <div style={{height:"1rem"}} />

                                        <Button onClick={handleSubmit}>提交</Button>

                                        <div style={{height:"3rem"}} />

                                        <Form.Group className="mb-3" controlId="formBasicEmail">
                                            <Form.Label size="lg">结果</Form.Label>
                                            <TextArea
                                                value={result}
                                                // placeholder="Controlled autosize"
                                                autoSize={{ maxRows: 5 }}
                                                // disabled
                                                bordered={false}
                                            />
                                            {/* <div id="demo"></div> */}
                                            
                                            
                                        </Form.Group>
                                        <div style={{height:"1rem"}} />
                                    </Form>
                                </Col>
                                <Col sm={1} />
                            </Row>
                        </Segment>
                    </Segment>
                </Content>
            </Layout>
            </Content>
            <Footer style={{ textAlign: 'center',minHeight: "10vh" }}>TIB ©2021 Created by Biodesign Center</Footer>
        </Layout>
    )
}
